.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  max-width: 720px;
}

.description {
  margin-bottom: 4px;
}

.section {
  margin-top: var(--tuna-spacing-3);
}

.sectionTitle {
  margin-bottom: 4px;
}

.field {
  margin-top: var(--tuna-spacing-1);
  max-width: 560px;
}

.status {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  min-height: 32px;
}

.statusText {
  margin: 0;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
}

.statusError {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-feedback-error);
}

.notice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
  margin-top: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
}
